<template lang="pug">
.parent-package-wrapper(:class="(active) ? 'active': ''")

  // to access
  router-link.tree-category(
    :to="{name:'ChildPackage', params:{family: item.pk}}"
    v-if="active || item.free"
  )
    .package-information
      span {{item.name}}

  // to purchase
  router-link.tree-category.to-purchase-link(
    v-if="!active && !item.free"
    :to="{name:'Payment', params:{family: item.pk}}"
  )
    .package-information
      span {{item.name}}
      label.price {{item|price}}
</template>

<script type="text/javascript">
import _ from "underscore"

export default {
  name: "ParentPackage",
  props: ["item", "me"],
  data() {
    return {
      active: false,
    }
  },
  created() {
    const self = this

    const subscriptions = this.me.subscriptions
    _.each(subscriptions, item => {
      const familyPk = item.family.pk
      if (self.item.pk == familyPk) self.active = true
    })
  },
  filters: {
    price: (newValue) => {
      const price = newValue.price
      const months = newValue.months
      if (!price) return "~ €"
      const fixedPrice = (price/100.0).toFixed(2)
      const latinPrice = `${fixedPrice}`.replace(".", ",")
      return `Acceda ${months} meses por ${latinPrice}€`
    }
  }
}
</script>
